function encodePolyline(points) {
  let lastLat = 0;
  let lastLng = 0;
  let result = "";

  const encodeSigned = (num) => {
    let s = num << 1;
    if (num < 0) s = ~s;
    return encodeUnsigned(s);
  };

  const encodeUnsigned = (num) => {
    let out = "";
    while (num >= 0x20) {
      out += String.fromCharCode((0x20 | (num & 0x1f)) + 63);
      num >>= 5;
    }
    out += String.fromCharCode(num + 63);
    return out;
  };

  for (const p of points) {
    const lat = Math.round(p.lat * 1e5);
    const lng = Math.round(p.lng * 1e5);

    result += encodeSigned(lat - lastLat);
    result += encodeSigned(lng - lastLng);

    lastLat = lat;
    lastLng = lng;
  }

  return result;
}

// 너무 많은 점은 줄여서 URL 안정성 확보
function downSample(points, maxPoints) {
  if (!points || points.length === 0) return [];
  if (points.length <= maxPoints) return points;

  const step = Math.ceil(points.length / maxPoints);
  const sampled = [];
  for (let i = 0; i < points.length; i += step) {
    sampled.push(points[i]);
  }
  if (sampled[sampled.length - 1] !== points[points.length - 1]) {
    sampled.push(points[points.length - 1]);
  }
  return sampled;
}

export function buildGoogleStaticMapUrl(points, options = {}) {
  const apiKey = options.apiKey;
  if (!apiKey) return null;

  const maxPoints = options.maxPoints ?? 120;
  const sampled = downSample(points, maxPoints);
  if (sampled.length === 0) return null;

  const sum = sampled.reduce(
    (acc, p) => ({ lat: acc.lat + p.lat, lng: acc.lng + p.lng }),
    { lat: 0, lng: 0 }
  );
  const centerLat = sum.lat / sampled.length;
  const centerLng = sum.lng / sampled.length;

  const encoded = encodePolyline(sampled);

  const size = options.size ?? "400x400";
  const zoom = options.zoom ?? 15;

  const path = `weight:5|color:0x00E0C6ff|enc:${encoded}`;

  return (
    "https://maps.googleapis.com/maps/api/staticmap" +
    `?center=${centerLat},${centerLng}` +
    `&zoom=${zoom}` +
    `&size=${size}` +
    `&maptype=roadmap` +
    `&path=${encodeURIComponent(path)}` +
    `&key=${encodeURIComponent(apiKey)}`
  );
}
